import { ChangeDetectionStrategy,Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

type ValuePart = { type: 'text', text: string }
    | { type: 'photoUrn', text: string, photoUrn: string }
    | { type: 'guid', text: string, guid: string }
    | { type: 'libraryResource', text: string, resourceId: string, url: string }
    ;

const libraryResourceRegex = /\$\(package:(?<owner>.+?)\/(.+?)\)\/([^ "');,:]+)/;
const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

@Component({
    selector: 'admin-linkified-text',
    imports: [
        RouterLink
    ],
    templateUrl: './linkified-text.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './linkified-text.component.scss'
})
export class LinkifiedTextComponent {
    @Input() text!: any;

    parseValue(value: any): ValuePart[] {
        if (typeof value !== 'string') {
            return [{ type: 'text', text: value.toString() }];
        } else {
            let words = value.split(' ');
            let result: ValuePart[] = [];
            for (let word of words) {
                let trimmedWord = this.trimQuote(word);
                if (trimmedWord.startsWith('urn:mediaclip:photo')) {
                    result.push({
                        type: 'photoUrn',
                        photoUrn: trimmedWord,
                        text: word,
                    });
                } else if (trimmedWord.startsWith('$(')) {
                    let group = 'librairies';
                    let match = trimmedWord.match(libraryResourceRegex);
                    if (match && match.groups) {
                        let owner = match.groups['owner'];
                        if (owner === 'mediaclip' || owner === 'mediaclip-tests' || owner === 'mediaclip-demo' || owner === 'mediaclip-fonts') {
                            group = 'mediaclip';
                        }
                        result.push({
                            type: 'libraryResource',
                            resourceId: trimmedWord,
                            text: word,
                            url: trimmedWord.replace(libraryResourceRegex, `https://git.mediacliphub.com/${group}/$1/tree/master/$2/$3`)
                        });
                    }
                } else if (trimmedWord.match(guidRegex)) {
                    result.push({
                        type: 'guid',
                        guid: trimmedWord,
                        text: word,
                    });
                } else {
                    let lastEntry = result[result.length - 1];
                    if (lastEntry && lastEntry.type === 'text') {
                        lastEntry.text += ' ' + word;
                    } else {
                        result.push({ type: 'text', text: word });
                    }
                }
            }

            return result;
        }
    }

    trimQuote(text: string): string {
        text = text.trim();
        if (this.isQuoted(text)) {
            return text.substring(1).substring(0, text.length - 2);
        }
        return text;
    }

    isQuoted(text: string) {
        if (text.startsWith('\'') && text.endsWith('\'')) {
            return true;
        }
        if (text.startsWith('`') && text.endsWith('`')) {
            return true;
        }
        if (text.startsWith('"') && text.endsWith('"')) {
            return true;
        }
        return false;
    }
}
